export const CHALLENGES = [
  // Daily Challenges
  { id: 'daily_checkin', title: 'Daily Check-In', description: 'Complete a mood check-in today', emoji: '📋', type: 'daily', points: 10 },
  { id: 'daily_breathing', title: 'Breathe Deep', description: 'Do a 2-minute breathing exercise', emoji: '🌬️', type: 'daily', points: 15 },
  { id: 'daily_journal', title: 'Write It Out', description: 'Write in your journal today', emoji: '✏️', type: 'daily', points: 20 },
  { id: 'daily_gratitude', title: 'Gratitude Moment', description: 'Log something you\'re grateful for', emoji: '🙏', type: 'daily', points: 10 },
  { id: 'daily_meditation', title: 'Mindful Minute', description: 'Complete a meditation session', emoji: '🧘', type: 'daily', points: 25 },
  
  // Weekly Challenges
  { id: 'weekly_streak', title: 'Streak Builder', description: 'Check in 5 days this week', emoji: '🔥', type: 'weekly', points: 50 },
  { id: 'weekly_coping', title: 'Coping Explorer', description: 'Try 3 different coping skills', emoji: '🗺️', type: 'weekly', points: 40 },
  { id: 'weekly_journal', title: 'Journal Journey', description: 'Write 3 journal entries this week', emoji: '📓', type: 'weekly', points: 45 },
  { id: 'weekly_bingo', title: 'Bingo Line', description: 'Complete a line in Wellness Bingo', emoji: '🎯', type: 'weekly', points: 60 },
  { id: 'weekly_voice', title: 'Voice Week', description: 'Do 2 voice check-ins this week', emoji: '🎙️', type: 'weekly', points: 35 },
  
  // Special Challenges
  { id: 'morning_checkin', title: 'Early Bird', description: 'Check in before 9 AM', emoji: '🌅', type: 'special', points: 15 },
  { id: 'evening_checkin', title: 'Night Owl', description: 'Check in after 9 PM', emoji: '🦉', type: 'special', points: 15 },
  { id: 'mood_improve', title: 'Rising Mood', description: 'Improve your mood by 2+ points today', emoji: '📈', type: 'special', points: 30 },
  { id: 'try_new_skill', title: 'New Skill', description: 'Try a coping skill you\'ve never used', emoji: '🆕', type: 'special', points: 25 },
  { id: 'share_progress', title: 'Share Joy', description: 'Share your progress with someone', emoji: '💝', type: 'special', points: 20 },
];

export const BADGE_CATEGORIES = ['All', 'Earned', 'checkin', 'streak', 'coping', 'wellness'];
export const BADGE_CATEGORY_LABELS = {
  'All': 'All',
  'Earned': 'Earned',
  'checkin': 'Check-ins',
  'streak': 'Streaks',
  'coping': 'Coping',
  'wellness': 'Wellness',
};

export const CHALLENGE_CATEGORIES = ['All', 'Daily', 'Weekly', 'Special'];
export const CATEGORY_COLORS = {
  checkin: '#4D96FF',
  streak: '#FF6B6B',
  coping: '#27AE60',
  wellness: '#E67E22',
};

export const CHALLENGE_TYPE_COLORS = {
  daily: '#4CAF50',
  weekly: '#2196F3',
  special: '#FF9800',
};

